import { styled } from '@linaria/react';

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: var(--base-gap);
`;
